import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/";

import ContentBox from "../../../components/UI/ContentBox";
import Footer from "../../../components/UI/Footer";
import Menu from "../../../components/UI/Menu";
import {
  Container,
  Questao,
  Section,
  MenuSelect,
  ContainerGraph,
  ButtonGroup,
  Text,
  TextCenter,
  List,
} from "./styles";
import Banner from "../../../components/UI/Banner";

import useApi from "../../../hooks/useApi";
import { useAuth } from "../../../hooks/useAuth";

import ReadMoreButton from "../../../components/UI/ReadMoreButton";
import FullScreenLoading from "../../../components/UI/FullScreenLoading";
import Modal from "../../../components/UI/Modal";
import { images } from "../../../constants";

import Grafico from './Grafico';

const ListForms = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const { user } = useAuth();

  const [sp, setSP] = useState({});

  const [open, setOpen] = useState("");
  
  const [returnSchool, setReturnSchool] = useState(0);

  const [school, setSchool] = useState("");

  const [supervisor, setSupervisor] = useState("");

  const [viewAllresponses, setViewAllresponses] = useState("");

  const [listSupervisor, setListSupervisor] = useState([]);

  const [responseData, setResponseData] = useState([]);

  const [listSchoolChoose, setListSchoolChoose] = useState([]);

  const [listSectorUnities, setListSectorUnities] = useState(false);

  const [loadFormResume, loadFormResumeInfo] = useApi({
    debounceDelay: 100,
    url: "canalPedagogico/form/allResponses/resume",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("response",response);
        if(response.data.formResponsesResume){
          setResponseData(response.data?.formResponsesResume);
          if(returnSchool===0){
            setReturnSchool(response.data?.formResponsesResume[0]?.formUnities.length);
          }
        }
      }
    },
  });

  const [getUnities, loadGetUnitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/form/allResponses/unitiesByChoice",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("responseUnities",response);
        setListSchoolChoose(response.data);
      }
    },
  });

  const [getListSupervisor, loadGetListSupervisorInfo] = useApi({
    debounceDelay: 0,
    url: "sectors",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("responseSupervisor",response);
        setListSupervisor(response.data?.sectors);
      }
    },
  });

  const clickItem = (temp)=>{
    console.log("clicktemp",temp);
    if(temp?.value?.idchoice && (school==="all" || supervisor!=="")){
      if(school==="all"){
        getUnities({
          params: {
            idform: id,
            idchoice:temp?.value?.idchoice,
          },
        });
      }
      if(supervisor!==""){
        getUnities({
          params: {
            idform: id,
            idchoice:temp?.value?.idchoice,
            idUser: supervisor,
          },
        });
      }
    }
  };

  useEffect(() => {
    if(id){
      loadFormResume({
        params: {
          idform: id,
        },
        debounced: true,
      });
    }
    if(user){
      setSP(user.profiles[0].specialPermissions.find((sp)=>{return sp.area==="forms"}).accessRights.find((category)=>{return category.idcategory==="41a9f494-0378-4272-b7d7-320e2a61f699"}));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if(sp.view_all_responses){
      getListSupervisor();
      console.log("load Supervisor");
    }
    console.log("sp",sp);
    // eslint-disable-next-line
  }, [sp]);

  useEffect(() => {
    if(school!==""){
      if(school==="all"){
        loadFormResume({
          params: {
            idform: id,
          },
        });
      }
      else{
        loadFormResume({
          params: {
            idform: id,
            idunity: school,
          },
        });
      }
    }
    else{
      loadFormResume({
          params: {
            idform: id,
          },
          debounced: true,
        });
    }
  }, [school]);

  useEffect(() => {
    if(supervisor!==""){
      loadFormResume({
        params: {
          idform: id,
          idUser: supervisor,
        },
      });
    }
    else{
      loadFormResume({
          params: {
            idform: id,
          },
          debounced: true,
        });
    }
  }, [supervisor]);

  useEffect(() => {
    console.log("responseData ",responseData);
    if(responseData[0]?.formUnities.length===1){
      if(supervisor===""){
        setSchool(responseData[0]?.formUnities[0].idunity);
      }
    }
    // eslint-disable-next-line
  }, [responseData]);

  return (
    <Container>
      {(
        loadFormResumeInfo.loading ||
        loadGetUnitiesInfo.loading
      ) && <FullScreenLoading />}
      <Menu />
      <Banner icon={images.iconAvaliacao}>Avaliação de contexto {returnSchool!==0 && ' - '} {responseData[0]?.formTitle}</Banner>
      <ContentBox>
        {returnSchool===0 && <TextCenter>Sua escola não possui respostas para este formulário</TextCenter>}

        <ButtonGroup>
          {viewAllresponses!=="" && school==="" && supervisor==="" && <ReadMoreButton text={"Voltar para a seleção de Listas"} onClick={()=>{
                      setViewAllresponses("");
                    }}/>}

          {returnSchool>1 && (school!=="" || supervisor!=="") && <ReadMoreButton text={"Voltar para a seleção de escolas"} onClick={()=>{
                      setSchool(""); setOpen(""); setSupervisor("");
                    }}/>}

          {open!=="" && <ReadMoreButton text={"Voltar para a seleção de questão"} onClick={()=>{
                      setOpen("")
                    }}/>}
          {sp.view_all_responses && school==="" && <ReadMoreButton text={"Lista das escolas que responderam o formulário"} onClick={()=>{
                      setListSectorUnities(true)
                    }}/>}
        </ButtonGroup>

        {returnSchool!==0 && school==="" && supervisor==="" && viewAllresponses==="" && <>
          <Text>Resultado geral:</Text>
          <MenuSelect visible={returnSchool!==0 && school==="" && supervisor===""} key={"all"} onClick={()=>{setSchool("all")}}>
            {sp?.view_all_response?
              <b>Gráfico consolidado com todas as escolas</b>:
              <b>Gráfico consolidado com todas as escolas do setor</b>}
          </MenuSelect>
        </>}

        {sp.view_all_responses && viewAllresponses==="" && school==="" && supervisor==="" && <>
          <Text>Resultado por setor: (Supervisor)</Text>
          <MenuSelect visible={sp.view_all_responses && viewAllresponses===""} key={"option1"} onClick={()=>{setViewAllresponses("Setor")}}><b>Listar Setores</b></MenuSelect>
          
          <Text>Resultados por escola: </Text>
          <MenuSelect visible={sp.view_all_responses && viewAllresponses===""} key={"option2"} onClick={()=>{setViewAllresponses("Escolas")}}><b>Listar Escolas</b></MenuSelect>
        </>}

        {(sp.view_all_responses && viewAllresponses==="Setor") && returnSchool!==0 && school==="" && supervisor==="" && <>
          <Text>Resultado por setor: (Supervisor)</Text>
          {listSupervisor.map((sup)=>
            <MenuSelect visible={returnSchool!==0 && school===""} key={sup.idSector} onClick={()=>{setSupervisor(sup.idUser)}}>
              {sup.userName}
            </MenuSelect>
          )}
        </>}


        {(!sp.view_all_responses||viewAllresponses==="Escolas") && returnSchool!==0 && school==="" && supervisor==="" && <>
          <Text>Resultados por escola: </Text>
          {responseData[0]?.formUnities.map((escola)=>(<MenuSelect visible={school===""} key={escola.idunity} onClick={()=>{setSchool(escola.idunity)}}>
            <p>{escola.name}</p>
          </MenuSelect>))}
        </>}


        {(school !== "" || supervisor!=="") && responseData[0]?.sections.map((section)=>(<Section key={`Menu-${section.idsection}`} visible={true}>
          {section.questions.map((question)=>(<MenuSelect key={`Menu-${question.idquestion}`} visible={open===""} onClick={()=>{setOpen(question.idquestion)}}>
            <p>{section.title.trim()!=="" && `${section.title} `}{question.text}</p>
          </MenuSelect>))}
        </Section>))}

        {responseData[0]?.sections.map((section)=>(<Section key={`${section.idsection}`} visible={true}>
          {section.questions.map((question)=>(<Questao key={`${question.idquestion}`} visible={open===question.idquestion} >
            <p>{section.title}</p>
            <p>{section.description}</p>

            <p>{question.text}</p>
            {/* <p>{question.type}</p> */}
            {question.type==="text" && <ul>
              {question.questionResponseText.filter((resp)=>{return resp.trim() !== ""}).sort().map((resp)=>(<li>{resp}</li>))}
            </ul>}
            {question.type==="date" && <ul>
              {question.questionResponseText.map((resp)=>(<li>
                {format(new Date(parseInt(resp)), " dd/MM/yyyy ")}
              </li>))}
            </ul>}
            {(question.type==="radio") && <ContainerGraph>
              {question.choices.length>0 && open===question.idquestion && 
              <Grafico 
                data={question.choices}
                visible={true}
                title={{text:``,top:"9%"}}
                changeType={true}
                clickOnGrafico={clickItem}
              />}
            </ContainerGraph>}
            {(question.type==="rowquestion_radio") && <ContainerGraph>
              {question.choices.length>0 && open===question.idquestion && 
              <Grafico 
                data={question.choices}
                visible={true}
                title={{text:``,top:"9%"}}
                changeType={true}
                clickOnGrafico={clickItem}
              />}
            </ContainerGraph>}
            {(question.type==="checkbox") && <ContainerGraph>
              {question.choices.length>0 && open===question.idquestion && 
              <Grafico 
                data={question.choices}
                visible={true}
                title={{text:``,top:"9%"}}
                clickOnGrafico={clickItem}
              />}
            </ContainerGraph>}
            {(question.type==="rowquestion_checkbox") && <ContainerGraph>
              {question.choices.length>0 && open===question.idquestion && 
              <Grafico 
                data={question.choices}
                visible={true}
                title={{text:``,top:"9%"}}
                clickOnGrafico={clickItem}
              />}
            </ContainerGraph>}
          </Questao>))}
        </Section>))}

        {open==="" && <ReadMoreButton text={"Voltar"} onClick={()=>{
                    navigate(`/formularios/listarresultados/a825ead6-c54d-4956-a82a-3a0301dca109`)
                  }}/>}

        <Modal open={listSchoolChoose.length>0} buttonClose={false}>
          <List>
            {listSchoolChoose.map((school)=><li>{school.name}</li>)}
          </List>
          <ReadMoreButton text={"Fechar"} onClick={()=>{setListSchoolChoose([])}}/>
        </Modal>

        <Modal open={listSectorUnities} buttonClose={false}>
          <TextCenter>{responseData[0]?.formUnities.length} Escolas</TextCenter>
          <List>
            {responseData[0]?.formUnities.map((escola)=>(<li key={escola.idunity}>
              {escola.name}
            </li>))}
          </List>
          <ReadMoreButton text={"Fechar"} onClick={()=>{setListSectorUnities(false)}}/>
        </Modal>
    
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ListForms;
